import selectors from '../../../rootSelectors';
import { activateNextButton } from '../../../common/screen/screenActions';
import { selectResponse } from '../../mazeActions';

export const onResponseSelected = (questionId, responseId) => (dispatch, getStore) => {
    const lastQuestion = selectors.getLastMazeQuestion(getStore());
    dispatch(selectResponse(questionId, responseId));
    if (questionId === lastQuestion.id) {
        dispatch(activateNextButton());
    }
};

export default onResponseSelected;
